import React, {Component} from 'react';
import {Field, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {Button} from 'material-ui';
import validateLogin from './validation';
import {InputTextField} from '../../../components/fields/field_input_text';

export class SignInForm extends Component {

    renderErrorMessage() {
        if (this.props.errorMessage) {
            return (
                <div>
                    {this.props.errorMessage}
                </div>
            )
        }
    }

    render() {
        const {handleSubmit} = this.props;

        return (
            <div className="loginBody">
                <div className="loginContent">
                    <div className="logo">
                        <img src={process.env.PUBLIC_URL + '/assets/logo.svg'} alt="logo" />
                    </div>
                    <form onSubmit={handleSubmit(this.props.onSignIn)}>
                        <Field name="username" type="text" component={InputTextField} label="Username" />
                        <Field name="password" type="password" component={InputTextField} label="Password" />
                        <span className="errMsg">{this.renderErrorMessage()}</span>
                        <Button type="submit" variant="raised" color="primary" className="loginButton">Submit</Button>{' '}
                    </form>
                </div>
            </div>
        )
    }
}

const form = reduxForm({
    form: 'SignInForm',
    validateLogin
});

SignInForm.contextTypes = {
    store: PropTypes.object
};

const mapStateToProps = state => ({ errorMessage: state.auth.error });

export default connect(mapStateToProps, { })(
    form(SignInForm)
);



// WEBPACK FOOTER //
// ./src/containers/auth/forms/sign_in_form.js